import { CareCuesInterface, RootState } from '../../';
import { InProgressResponse } from './interfaces';
import { REMINDER_STATUS } from '@ax/constants';
import { createSelector } from '@reduxjs/toolkit';

export const noteHasPendingCareCuesResponses = (noteId: string) => {
  return (state: RootState): boolean => {
    return state.careCues.inProgressResponses.some(
      (response: InProgressResponse) => response.noteId === noteId,
    );
  };
};

export const selectCareCues = createSelector(
  (state: RootState) => state.careCues.reminders as CareCuesInterface[],
  (reminders) => {
    return reminders.filter((reminder: CareCuesInterface) =>
      reminder.items.some((item) => [REMINDER_STATUS.UNSATISFIED].includes(item.status)),
    );
  },
);

export const selectIsCareCuesLoading = (state: RootState): boolean => state.careCues.loading;
